export default "__VITE_ASSET__DLuNL$Ts__"